/**
 * @file   src\Pages\SignIn.tsx
 * @brief  SignIn page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, Button, Link, useState, useNavigate, useEffect } from '../utils/thirdpartyComponents';
import Carwashlogo from '../assets/images/CarWash-Logo.svg';
import CWInput from '../components/CWInput';
import '../styles/signin.scss';
import * as Yup from 'yup'
import { pageURLs } from '../utils/pageUrls';
import { FORGOTPASSWORD_STEP1_SCHEMA } from '../validations/forgotPasswordSchema';
import { EMAIL_MAX_LENGTH } from '../utils/constants';
import { MessageToaster } from '../utils/toastUtil';
import axios from '../config/axiosConfig';
import { AuthApi } from '../utils/apiUrls';
import { userType } from '../utils/enums';
import FullLoader from '../components/FullLoader';

const ForgotPasswordStep1 = (props:any) => {
    const navigate = useNavigate();
    // Toast object creation.
    const toaster = new MessageToaster();

    // Initialize states for formdata
    const [formData, setFormData] = useState({
        email: '',
        adminUserType: props.userType

    })
    const [loading, setLoading] = useState(false);

    // Handle errors
    const [errors, setErrors] = useState({
        email: '',
    });

    useEffect(() => {
        localStorage.clear()
    }, []);

    

    const onInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;

        // To remove validation when user enters input
        const keys = Object.keys(errors);
        if (keys.includes(name)) {
            setErrors({
                ...errors,
                [name]: ""
            })
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };


    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        setLoading(true)
        e.preventDefault()
        try {
            localStorage.setItem('forgotemail',formData.email)
            // Validate form data
            await FORGOTPASSWORD_STEP1_SCHEMA.validate(formData, { abortEarly: false });
            const { data } = await axios.post(AuthApi.FORGOT_PASSWORD,formData);
            if (data?.error == 0) {
              // Navigate to otp verification page
              if(props.userType == userType['SUPER-ADMIN'])
              {
                navigate(`/superadmin/${pageURLs.forgotpassword_step2}`)
              }
              else
              {
                navigate(`/${pageURLs.forgotpassword_step2}`)

              }
               
            }
            else {
                // show error message
                toaster.toastError(data?.message);
            }
            

        } catch (error) {
            //If validation fails on submit, then errors are shown
            if (error instanceof Yup.ValidationError) {
                const newErrors: any = {};
                error.inner.forEach((err) => {
                    newErrors[err.path as keyof typeof formData] = err.message;
                });
                setErrors(newErrors);
            }
        }
        setLoading(false)
    }

    return (
        <div>
            <div className="signin-bg"></div>
            <div className="signin-wrap d-flex">
                <div className="signin-container d-grid">
                    <div className="signin-hero d-flex align-items-start flex-column justify-content-center">
                        <img src={Carwashlogo} alt="Car Wash App" />
                        <h1>{props.userType === userType['SUPER-ADMIN'] ? 'Super Admin' : 'Car Wash Owner'} </h1>
                    </div>
                    <div className="signin-form-wrap password-form-wrap">
                        <h2>Forgot Password</h2>
                        <p className='sub'>Enter your registered email address below. A verification code will be sent to the email.</p>
                        <form onSubmit={handleSubmit}>
                            <CWInput
                                id="email"
                                name="email"
                                type="text"
                                label="Email Address"
                                value={formData.email}
                                onChange={onInputChange}
                                maxLength={EMAIL_MAX_LENGTH}
                                autoFocus
                                errorMessage={errors.email && errors.email}

                            />
                            <Button
                                title='Submit'
                                type="submit"
                                variant="primary"
                                className="primary-btn"
                            >
                                Submit
                            </Button>
                        </form>
                        <div className="new-user text-center">Back to  <Link to={`/superadmin/${pageURLs.root}`} title="Sign In" >Sign In</Link></div>
                    </div>
                </div>
            </div>
            {loading && <FullLoader />}
        </div>
        
    )
}

export default ForgotPasswordStep1;
